import {
  Children,
  type PropsWithChildren,
  type ReactElement,
  type ReactNode,
} from 'react';

import { IntentProps } from '../../../../../core/slots/Intent/Intent.js';
import { isSlot } from '../../../../../core/utils/is-slot.js';
import { ChartSeriesAction } from '../../series-action/ChartSeriesAction.js';
import { Intent } from '../../series-action/components/Intent.js';
import {
  ChartSeriesActionItemProps,
  Item,
} from '../../series-action/components/Item.js';
import { ItemIcon } from '../../series-action/components/ItemIcon.js';
import {
  ActionItem,
  ActionItemProps,
} from '../../tooltip/ChartTooltip/components/ActionItem/ActionItem.js';

const renderActionItem = (
  item: ReactElement<PropsWithChildren<ChartSeriesActionItemProps>>,
) => {
  const itemProps: ActionItemProps = {
    onMouseUp: item.props.onSelect,
    text: '',
    icon: '',
  };

  Children.forEach(item.props.children, (itemPart) => {
    if (isSlot(itemPart, ItemIcon)) {
      itemProps.icon = itemPart.props.children;
    } else {
      itemProps.text = itemPart;
    }
  });

  return <ActionItem {...itemProps} />;
};

export const getCustomContextMenuItems = (customItem: ReactNode) => {
  let actions: ReactElement<PropsWithChildren<ChartSeriesActionItemProps>>[] =
    [];
  let intents: ReactElement<PropsWithChildren<IntentProps>>[] = [];

  Children.forEach(customItem, (action) => {
    if (isSlot(action, ChartSeriesAction)) {
      const { actions: recursiveActions, intents: recursiveIntents } =
        getCustomContextMenuItems(action.props.children);
      actions = [...actions, ...recursiveActions];
      intents = [...intents, ...recursiveIntents];
    } else if (isSlot(action, Item)) {
      actions = [...actions, renderActionItem(action)];
    } else if (isSlot(action, Intent)) {
      intents = [...intents, action];
    }
  });

  return { actions, intents };
};
